import { render, staticRenderFns } from "./AppPointRecord.vue?vue&type=template&id=7ac98796"
import script from "./AppPointRecord.vue?vue&type=script&lang=js"
export * from "./AppPointRecord.vue?vue&type=script&lang=js"
import style0 from "./AppPointRecord.vue?vue&type=style&index=0&id=7ac98796&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports